import { Button } from "@/components/ui/button";
import { useProductRefresh } from "@/services/useProductList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoltLightning } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";

export default function PlaceSyncInfo({ place }) {
  const [displayedDate, setDisplayedDate] = useState(place.product_cache_date);
  const productRefresh = useProductRefresh({ placeId: place?.msdsId });

  if (!place) return null;

  const cacheDate = new Date(displayedDate);
  const isValidDate = !isNaN(cacheDate.getTime()) && cacheDate.getTime() > 0;

  const refresh = e => {
    e.preventDefault();
    productRefresh.mutate();
    setDisplayedDate(new Date().toISOString());
  };

  const syncButton = (
    <Button
      disabled={productRefresh.isPending}
      onClick={refresh}
      size="sm"
      className="ml-2"
    >
      <FontAwesomeIcon icon={faBoltLightning} />
      Forcer la mise à jour
    </Button>
  );

  return (
    <>
      <div className="flex flex-col justify-center items-center gap-2">
        <div className='flex flex-col justify-center items-center w-full bg-gray-50 p-2 rounded-md'>
          <p>
            {isValidDate
              ? <span>Mis à jour depuis Resamania 
                le {cacheDate.toLocaleString('fr-FR', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit',
                  hour12: false,
                })}
                </span>
              : <span>Informations non synchronisées</span>
            }
            {syncButton}
          </p>
        </div>
      </div>
    </>
  );
}
